import AppOnboardingContainer from "./AppOnboardingContainer";

export default AppOnboardingContainer;

